var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { BuildOptionsService } from './build-options.service';
import { environment } from '../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./auth.service";
import * as i3 from "./build-options.service";
var TokenService = /** @class */ (function () {
    function TokenService(http, auth, buildOptionsService) {
        this.http = http;
        this.auth = auth;
        this.buildOptionsService = buildOptionsService;
        this.isTokenExpired = false;
    }
    TokenService.prototype.checkTokens = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (this.auth.loggedIn()) {
                    return [2 /*return*/, new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
                            var expires, seconds, refreshToken, res, err_1;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 4, , 5]);
                                        expires = this.auth.getExpires();
                                        seconds = Math.floor(new Date().getTime() / 1000);
                                        refreshToken = this.auth.getRefresh();
                                        if (!(expires < seconds + 50)) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.http
                                                .post(environment.apiURL + "/auth", { refreshToken: refreshToken }, {
                                                headers: this.buildOptionsService.buildOptions()
                                            })
                                                .toPromise()
                                                .catch(function (err) {
                                                console.log(err);
                                                _this.isTokenExpired = true;
                                                _this.auth.logout();
                                            })];
                                    case 1:
                                        res = _a.sent();
                                        if (res && res.expires) {
                                            this.auth.login(res.expires, res.refreshToken, res.jwt, res.deviceToken, {
                                                id: res.id,
                                                role: res.role,
                                                fname: res.fname,
                                                lname: res.lname,
                                                managedTeams: res.managedTeams,
                                                userType: res.userType,
                                                subscriptions: res.subscriptions
                                            });
                                            resolve();
                                        }
                                        else {
                                            this.isTokenExpired = true;
                                            this.auth.logout();
                                            resolve();
                                        }
                                        return [3 /*break*/, 3];
                                    case 2:
                                        resolve();
                                        _a.label = 3;
                                    case 3: return [3 /*break*/, 5];
                                    case 4:
                                        err_1 = _a.sent();
                                        this.isTokenExpired = true;
                                        resolve(err_1);
                                        return [3 /*break*/, 5];
                                    case 5: return [2 /*return*/];
                                }
                            });
                        }); })];
                }
                else {
                    return [2 /*return*/];
                }
                return [2 /*return*/];
            });
        });
    };
    TokenService.ngInjectableDef = i0.defineInjectable({ factory: function TokenService_Factory() { return new TokenService(i0.inject(i1.HttpClient), i0.inject(i2.AuthService), i0.inject(i3.BuildOptionsService)); }, token: TokenService, providedIn: "root" });
    return TokenService;
}());
export { TokenService };
